import {
  addCurrencyRate,
  removeCurrencyRate,
  updateCurrencyRate,
} from './settingsForm';

export function getCheckConversionCurrencies(items, checkCurrency, defaultItemCurrency) {
  if (!checkCurrency) return [];
  const codes = new Set();
  for (const item of items || []) {
    const currency = item?.currency || defaultItemCurrency;
    if (currency && currency !== checkCurrency) {
      codes.add(currency);
    }
  }
  return [...codes].sort();
}

export function buildCheckExchangeRateRows(
  requiredFromCurrencies,
  checkCurrency,
  exchangeRates = [],
  companyCurrencyRates = [],
) {
  return requiredFromCurrencies.map((fromCurrency) => {
    const stored = (exchangeRates || []).find(
      (row) => row.fromCurrency === fromCurrency
        && (row.toCurrency === checkCurrency || !row.toCurrency),
    );
    if (stored) {
      return {
        fromCurrency,
        toCurrency: checkCurrency,
        rate: stored.rate ?? '',
      };
    }
    const companyRow = (companyCurrencyRates || []).find(
      (row) => row.fromCurrency === fromCurrency && row.toCurrency === checkCurrency,
    );
    if (companyRow) {
      return {
        fromCurrency,
        toCurrency: checkCurrency,
        rate: companyRow.rate ?? '',
      };
    }
    return { fromCurrency, toCurrency: checkCurrency, rate: '' };
  });
}

export function mapCheckExchangeRatesToForm(exchangeRates, checkCurrency) {
  return (exchangeRates || []).map((row) => ({
    fromCurrency: row.fromCurrency || '',
    toCurrency: row.toCurrency || checkCurrency || '',
    rate: row.rate ?? '',
  }));
}

export function buildCheckExchangeRatesPayload(rates, checkCurrency) {
  return {
    exchangeRates: (rates || []).map((row) => ({
      fromCurrency: row.fromCurrency,
      toCurrency: row.toCurrency || checkCurrency,
      rate: Number(row.rate),
    })),
  };
}

export { addCurrencyRate, removeCurrencyRate, updateCurrencyRate };
